import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from "@xref/xref-lib";
import { ChangePlanModalComponent } from "./change-plan-modal.component";



@NgModule({
  declarations: [ChangePlanModalComponent],
  imports: [
    CommonModule, ButtonModule
  ],
  exports: [ChangePlanModalComponent],
})
export class ChangePlanModalModule { }
